"use strict";

var _bootstrap = require("@insided/destination/app/bootstrap");

require("../../../sass/src/default-style.scss");

(0, _bootstrap.bootstrap)();